import { memo } from 'react';
import type { BoolStarFilterViewModel } from 'autogen/swagger/all';
import FilterMenuDrawer from '../../FilterMenu/FilterMenuDrawer';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import BooleanStarFilterOption from './BooleanStarFilterOption';

const BooleanStarFilterMenu = ({
    model: {
        displayName,
        options,
        queryStringName,
        attribute: { id }
    }
}: {
    model: BoolStarFilterViewModel;
}) => {
    const filterMenuId = id.toString();
    const { closeFilterMenu } = useFilterMenu(filterMenuId);

    return (
        <FilterMenuDrawer id={filterMenuId} headline={displayName} backButtonCallback={closeFilterMenu}>
            {options.map((option) => (
                <BooleanStarFilterOption
                    key={option.displayName}
                    model={option}
                    queryStringName={queryStringName}
                    menuDisplayName={displayName}
                />
            ))}
        </FilterMenuDrawer>
    );
};

export default memo(BooleanStarFilterMenu);
